import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { CreatedBy } from '../../../core/models/userModel';

export interface AssignUserDialogData {
  users: CreatedBy[];
  selectedUserId: number | null;
}

@Component({
  selector: 'app-assign-user-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatSelectModule, FormsModule],
  templateUrl: './assign-user-dialog.html',
  styleUrl: './assign-user-dialog.scss',
})
export class AssignUserDialog {
  private dialogRef = inject(MatDialogRef<AssignUserDialog>);
  data = inject<AssignUserDialogData>(MAT_DIALOG_DATA);

  selectedUserId: number | null = this.data.selectedUserId ?? null;

  close(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    this.dialogRef.close(this.selectedUserId);
  }
}
